import { render, staticRenderFns } from "./CorporativeAccountForm.vue?vue&type=template&id=e5b3612e"
import script from "./CorporativeAccountForm.vue?vue&type=script&lang=js"
export * from "./CorporativeAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports